import { AspectRatio, forwardRef } from "@chakra-ui/react";

export const PlayVideo = forwardRef(function PlayVideo(props, ref) {
  const { src, ...rest } = props;
  return (
    <AspectRatio my={4} ratio={16 / 9} {...rest}>
      <iframe
        src={`${src}?enablejsapi=1`}
        allow="autoplay; fullscreen"
        allowFullScreen
        title="Vimeo Video"
        ref={ref}
      />
    </AspectRatio>
  );
});
